export const styles = (theme) => ({
  root: {
    // marginTop : theme.spacing(2),
    padding: 0,
  },
  editorCss: {
    lineHeight: "2rem",
    minHeight: "100px",
    // maxHeight: '600px',
    // height: '20rem',
    border: "1px solid #e6e6e6",

    overflow: "unset",
  },
  customFormLabel: {
    display: "block",
    transformOrigin: "top left",
    transform: "translate(0, 1.5px) scale(0.75)",
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: "500",
  },
  containerLabel: {
    paddingBottom: "0 !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  customIcon: {
    height: "30px",
    background: "white",
    cursor: "pointer",
    border: "1px solid #F1F1F1",
    borderRadius: "2px",
    margin: "0 3px",
    textTransform: "capitalize",
    background: "white",
  },
  title: {
    padding: "0",
    fontSize: "1rem",
    textAlign: "center",
    marginTop: "1.5rem",
    marginBottom: "1.5rem",
    fontWeight: "500",
    lineHeight: "normal",
  },
  customIcon: {
    paddingLeft: "5px",
    color: "#000000ab",
    height: "30px",
    background: "white",
    cursor: "pointer",
    border: "1px solid #F1F1F1",
    borderRadius: "2px",
    margin: "0 3px",
    textTransform: "capitaliz",
    background: "white",
    paddingRight: "5px",
  },
  DialogContent: {
    lineHeight: 1.5,
  },
});
